import * as Yup from 'yup';
export const signin_validationSchema = Yup.object({
    email: Yup.string().email().required("Please enter username"),
    password: Yup.string().required("Please fill the password")
  });